import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddVideosComponent } from '../add-videos/add-videos.component';
import { Store } from '@ngrx/store';
import { deleteVideo, loadVideos } from '../../action/video.actions';
import { Video } from '../../model/video';
import { Observable, Subscribable } from 'rxjs';
import { MainserviceService } from 'src/app/mainservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

declare var $: any;
@Component({
  selector: 'app-view-videos',
  templateUrl: './view-videos.component.html',
  styleUrl: './view-videos.component.scss'
})
export class ViewVideosComponent implements OnInit{
  videos: Video[] = [];
videoCategories = [
  { id: "1", name: 'Medeil' },
  { id: "2", name: 'Medeil Cloud POS' },
  { id: "3", name: 'Medeil Cloud HQ' },
  { id: "4", name: 'Hosbay' },
  { id: "5", name: 'Allotmed' }
];
gifLoader: boolean;
  constructor(public dialog: MatDialog,private store:Store<{video:{video:Video[]}}>,
    private service:MainserviceService,private snackBar: MatSnackBar,private sanitizer: DomSanitizer,private router: Router){
    this.store.dispatch(loadVideos());
      this.gifLoader=true;
  }
  ngOnInit(): void {
    this.store.select((state:any) => state.video.loading).subscribe(loading => {
      this.gifLoader = loading;
    });
    this.store.select('video').subscribe((state: { video: Video[] }) => {
      this.videos = state.video.map(video => ({
        ...video,
        embedUrl: this.getEmbedUrl(video.videolink)
      }));
    });
  }
  openVideoPopup() {
    const dialogRef = this.dialog.open(AddVideosComponent, {
      width: '600px',
      data: {  } as any
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Video Data:', result);
      }
    });
  }
  getVideosByCategory(categoryId: number) {
    return this.videos.filter((video:any) => video.category === categoryId);
  }

  edit(video){
    const dialogRef = this.dialog.open(AddVideosComponent, {
      width: '600px',
      data: { video} as any
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.snackBar.open('Video added successfully!', 'Close', { duration: 3000 });
      }
    });
  }
  deletevideo(id:any){
    this.store.dispatch(deleteVideo({id:id}))
    this.snackBar.open('Video Deleted successfully!', 'Close', { duration: 3000 });
  }
  isEmbed(videoUrl: string): boolean {
    // Check if it's a YouTube, Facebook, Instagram, or Twitter link
    return (
      videoUrl.includes('youtube.com') ||
      videoUrl.includes('youtu.be') ||
      videoUrl.includes('facebook.com') ||
      videoUrl.includes('instagram.com') ||
      videoUrl.includes('twitter.com')
    );
  }

  isDirectVideo(videoUrl: string): boolean {
    // Check if it's a direct video file (MP4, WebM, OGG)
    return videoUrl.match(/\.(mp4|webm|ogg)$/) !== null;
  }

  getEmbedUrl(videoUrl: string): SafeResourceUrl {
    let embedUrl = '';

    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      embedUrl = videoUrl.replace('watch?v=', 'embed/');
    } else if (videoUrl.includes('facebook.com')) {
      embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(videoUrl)}&show_text=0&width=560`;
    } else if (videoUrl.includes('instagram.com')) {
      embedUrl = `https://www.instagram.com/p/${this.extractInstagramId(videoUrl)}/embed/`;
    } else if (videoUrl.includes('twitter.com')) {
      embedUrl = `https://twitframe.com/show?url=${encodeURIComponent(videoUrl)}`;
    } else {
      // If it's not an embed URL, return a safe URL for direct video
      return this.sanitizer.bypassSecurityTrustUrl(videoUrl);
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  extractInstagramId(url: string): string {
    const parts = url.split('/');
    return parts[parts.length - 2]; // Extracts the post/reel ID from the URL
  }
  viewPage(video: any) {

    this.router.navigate(['/more-details', video.seo_url], { state: { video } });
  }
}
